import { useMemo, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider, CssBaseline, useMediaQuery } from '@mui/material'
import { getSuiteTheme, SuiteNavbar } from '@tysnxu/suite-ui'
import App from './App'
import { StartPage } from './StartPage'
import './style.css'

// The hub isn't deployed yet, so fall back to its local dev port; once
// tools.tysnxu.qzz.io is live this becomes the only branch.
const TOOLS_JSON_URL = import.meta.env.DEV
  ? 'http://localhost:5183/tools.json'
  : 'https://tools.tysnxu.qzz.io/tools.json'

function Root() {
  const dark = useMediaQuery('(prefers-color-scheme: dark)')
  const theme = useMemo(() => getSuiteTheme(dark ? 'dark' : 'light'), [dark])
  // The model download only begins when <App> mounts, so the landing page
  // costs nothing until the user opts in.
  const [started, setStarted] = useState(false)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SuiteNavbar toolsJsonUrl={TOOLS_JSON_URL} title="Vocal Remover" />
      {started ? <App /> : <StartPage onStart={() => setStarted(true)} />}
    </ThemeProvider>
  )
}

// Deliberately not wrapped in StrictMode: its double-invoked effects would spawn
// the separation worker twice and start a second 33 MB model download on every
// dev reload.
createRoot(document.getElementById('root')!).render(<Root />)
